import React from "react";
import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/js/bootstrap";
import { isLoggedIn } from "../store/auth";
import { connect } from "react-redux";

const PARTIES_AND_EVENTS = "Parties & Events";
const HOME = "Home";
const POST_EVENT = "Post event";
const MY_EVENTS = "My events";
const SYSTEM_EVENTS = "System events"; 
const PROFILE = "Profile";
const ABOUT = "About";
const LOGOUT = "Logout";
const LOGIN = "Login";
const REGISTER = "Register";

const NavBar = ({currentUser}) => {
  
  const isAdmin = currentUser? currentUser.isAdmin: false; 
  
  return (
    <nav
      // className="navbar navbar-expand-lg navbar-light bg-light fixed-top"
      className="navbar navbar-expand-lg navbar-dark fixed-top shadow bg-dark text-light"
      data-toggle="collapse"
      data-target=".navbar-collapse.show"

    >
      {/* <Link className="navbar-brand" to="/">
        <i
          className="fa fa-university fa-lg text-secondary mr-0"
          aria-hidden="true"
        ></i>
      </Link> */}
      <Link className="navbar-brand mt-2 ml-3 justify-content-start" to="/">
        <div className="row">
          <h4 className="justify-content-md-start text-light">
          <i className="fa fa-home" aria-hidden="true" /> {PARTIES_AND_EVENTS}
          </h4>
        </div>
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarNav"
      >
        <div className="navbar-nav">

          {/* <NavLink className="nav-item nav-link font-weight-bold" to="/about">
            <i className="fa fa-home" aria-hidden="true" /> {HOME}
          </NavLink> */}

          {isLoggedIn() ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/events/form/new"
            >
              <i className="fa fa-plus" aria-hidden="true" /> {POST_EVENT}
            </NavLink>
          ) : null}

          {isLoggedIn() ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/profile"
            >
              <i className="fa fa-user" aria-hidden="true" /> {PROFILE}
            </NavLink>
          ) : null}

          {isLoggedIn() ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/my-events"
            >
              <i className="fa fa-bars" aria-hidden="true" /> {MY_EVENTS}
            </NavLink>
          ) : null}

          {isLoggedIn() && isAdmin? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/system-events"
            >
              <i className="fa fa-list-ul" aria-hidden="true" /> {SYSTEM_EVENTS}
            </NavLink>
          ) : null}

            

          {/* <NavLink
            className="nav-item nav-link font-weight-bold"
            to="/howToUse"
          >
            <i className="fa fa-question" aria-hidden="true" /> Como Usar
          </NavLink> */}

          {/* {!loggedIn ? (
            <NavLink className="nav-item nav-link font-weight-bold" to="/login">
              Entrar
            </NavLink>
            
          ) : null} */}
          {isLoggedIn() ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/logout"
            >
              <i className="fa fa-sign-out" aria-hidden="true" /> {LOGOUT}
            </NavLink>
          ) : (
            <NavLink className="nav-item nav-link font-weight-bold" to="/login">
              <i className="fa fa-sign-in" aria-hidden="true" /> {LOGIN}
            </NavLink>
          )}

          {!isLoggedIn() ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/register"
            >
              <i className="fa fa-user-plus" aria-hidden="true" /> {REGISTER}
            </NavLink>
          ) : null}

          {/* <NavLink className="nav-item nav-link font-weight-bold" to="/about">
            <i className="fa fa-question-circle-o" aria-hidden="true" /> {ABOUT}
          </NavLink> */}
          
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
});

// const mapDispatchToProps = (dispatch) => ({
//   getCurrentUser: () => dispatch(getCurrentUser()),
// });

export default connect(mapStateToProps)(NavBar);
